import React from "react";

import { useLimit } from "./hooks";

export const LimitMobile = React.memo(() => {
  const { getLimitProps, values } = useLimit();
  return (
    <div {...getLimitProps()}>
      <span>
        {values.max}&nbsp;{values.balanceLabel}
      </span>
      <span>MAX. ПРОГНОЗ</span>
    </div>
  );
});

LimitMobile.displayName = "LimitMobile";
